const apiUrl = process.env.REACT_APP_API_URL;

export const ToggleAulaBloqueoFoco = async (idAula: string | number, bloqueoFoco: boolean) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${idAula}/toggle-bloqueo-foco?bloqueoFoco=${bloqueoFoco}`, {
            method: 'POST'
        });
        if (response.ok) {
            return await response.json();
        }
        return null;
    } catch (error) {
        console.error('Error toggling aula bloqueo foco:', error);
        return null;
    }
};
